import { Drawer, List } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import { PromoCodeTermsDrawerProps } from './types'
import parse from 'html-react-parser'
import { PROMO_CODE_KEY_MAPPING } from './constants'
import { PRODUCT_PROMO_CODES } from 'components/promo-code/constants'
import { useGetLanguage } from 'hooks/useGetLanguage'
import { getPlentyPromoConditions } from './utils'

const PromoCodeTermsDrawer = ({ code, ...props }: PromoCodeTermsDrawerProps) => {
  // i18n
  const { t } = useTranslation(['simulation', 'common'])
  const language = useGetLanguage()

  // Constants
  const specificConditions = code ? PROMO_CODE_KEY_MAPPING[code]?.[language] : null

  // Plenty promo specifics
  // Not included in the specific conditions mapping as it's a dynamic promo code that changes every month but the text remains the same.
  const isPlentyPromoCode = code && PRODUCT_PROMO_CODES.has(code)
  const plentyPromoConditions = isPlentyPromoCode ? getPlentyPromoConditions(code, language, t) : null

  return (
    <Drawer {...props} title={t(($) => $.terms.promo.title)}>
      {!isPlentyPromoCode && (
        <section className="flex-col gap-400">
          <p>{t(($) => $.terms.promo.general.description)}</p>
          <List as="ul">
            {t(($) => $.terms.promo.general[isPlentyPromoCode ? 'bullets_oneOff' : 'bullets_spread'], { returnObjects: true }).map(
              (text, idx) => (
                <li key={`general_${idx}`}>{text}</li>
              )
            )}
          </List>
        </section>
      )}

      {plentyPromoConditions && (
        <section className="flex-col gap-400">
          <List as="ul">
            {plentyPromoConditions?.map((text, idx) => (
              <li key={`plenty_${idx}`}>{text}</li>
            ))}
          </List>
        </section>
      )}

      {specificConditions && (
        <section className="flex-col gap-400">
          <p>{parse(t(($) => $.terms.promo.specificConditions.description, { code }))}</p>
          <List as="ul">
            {specificConditions?.map((text, idx) => (
              <li key={`specific_${idx}`}>{text}</li>
            ))}
          </List>
        </section>
      )}
    </Drawer>
  )
}

export default PromoCodeTermsDrawer
